import type { FC, SVGProps } from "react";

const IconFreeCancellation: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M3.2 3.19995C2.84843 3.35332 2.54839 3.60456 2.33562 3.9237C2.12286 4.24285 2.00636 4.61644 2 4.99995V19C2 19.5304 2.21071 20.0391 2.58579 20.4142C2.96086 20.7892 3.46957 21 4 21H18C18.3847 20.9991 18.761 20.8874 19.0839 20.6781C19.4067 20.4688 19.6623 20.1709 19.82 19.82" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M20 14.5V5C20 4.46957 19.7893 3.96086 19.4142 3.58579C19.0391 3.21071 18.5304 3 18 3H8.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15 1V5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2 9H9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M20 9H14.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1 1L21 21" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconFreeCancellation;
